/**
 * setABLeg.js
 * Written by: Alex Kasemir
 */

export const SET_AB_LEG_SUCCESS = `SET_AB_LEG_SUCCESS`;

export const setABLegSuccess = (test, leg) => ({
  type: SET_AB_LEG_SUCCESS,
  test,
  leg,
});

/**
 * Description of the setABLeg action
 */
export const setABLeg = ({
  testName,
  variations,
  percentage = 100,
  trigger = () => true,
}, tries = 0) => {
  return (dispatch, getState) => {
    if (!getState().extra.abLeg[testName]) {
      if (process.env.NODE_ENV === `production` && __CLIENT__ && tries < 5) {
        if (typeof Piwik === `undefined`) {
          setTimeout(() => {
            dispatch(setABLeg({ testName, variations, percentage, trigger }, tries + 1));
          }, 3000);
        } else {
          const { Experiment } = Piwik.AbTesting;
          const myExper = new Experiment({
            name: testName,
            percentage,
            includedTargets: [{ attribute: `url`, inverted: `0`, type: `any`, value: `` }],
            excludedTargets: [],
            variations,
            trigger,
          });
          const selectedVariation = myExper.getActivatedVariationName();
          dispatch(setABLegSuccess(testName, selectedVariation));
        }
      } else {
        const selectedIndex = Math.floor(Math.random() * variations.length);
        const selectedVariation = variations[selectedIndex].name;
        dispatch(setABLegSuccess(testName, selectedVariation));
      }
    }
  };
};

export default setABLeg;
